import PropTypes from 'prop-types';
import DateInput from 'components/forms/dynamic-form-inputs/date-input';
import TextField from 'apps/interactions/form/fields/standard-fields/text-field';
import NumberInput from 'components/forms/dynamic-form-inputs/number-input';
import SwitchInput from 'components/forms/dynamic-form-inputs/switch-input';
import InteractionTypeField from 'apps/interactions/form/fields/shared-fields/interaction-type-field';
import { DynamicField } from '@evertrue/sdk';
import { useInteractionFormContext } from 'apps/interactions/form/context/interaction-form-context';

const DxoBody = ({ values }) => {
  const { hasInteractionWrites } = useInteractionFormContext();
  return (
    <>
      <div className="form-row">
        <DynamicField
          name="interaction_type"
          label="Interaction Type"
          values={{ ...values, has_interaction_writes: hasInteractionWrites }}
          as={InteractionTypeField}
        />
        <DynamicField name="substantive" label="Substantive" values={values} as={SwitchInput} />
      </div>
      <div className="form-row">
        <DynamicField name="ask_date" values={values} as={DateInput} triggerClassName="ignore-margin" />
        <DynamicField
          name="ask_amount"
          values={values}
          as={NumberInput}
          integerLimit={10}
          allowDecimal={true}
          placeholder={0}
          maskType="currency"
          showIcon={true}
        />
      </div>
      <DynamicField name="text" label="Description" values={values} as={TextField} wrap={true} type={'dxo'} />
    </>
  );
};

DxoBody.propTypes = {
  values: PropTypes.object.isRequired,
};
export default DxoBody;
